<template>
  <div class="date-range-picker">
    <Datepicker 
      v-model="dateRange" 
      range 
      :enable-time-picker="false"
      placeholder="Select date range"
      @update:model-value="handleDateChange"
      :format="format"
      auto-apply
    />
  </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';

export default {
  name: 'DateRangePicker',
  components: {
    Datepicker
  },
  props: {
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    }
  },
  emits: ['change'],
  data() {
    return {
      dateRange: null
    };
  },
  watch: {
    startDate: {
      immediate: true,
      handler(newVal) {
        this.updateDateRange();
      }
    },
    endDate: {
      immediate: true,
      handler(newVal) {
        this.updateDateRange();
      }
    }
  },
  methods: {
    updateDateRange() {
      if (this.startDate && this.endDate) {
        this.dateRange = [
          new Date(this.startDate),
          new Date(this.endDate)
        ];
      }
    },
    format(dates) {
      if (!dates || !dates.length) return '';
      const start = moment(dates[0]).format('MM/DD/YYYY');
      const end = moment(dates[1]).format('MM/DD/YYYY');
      return `${start} - ${end}`;
    },
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        const startDate = moment(dates[0]).format('YYYY-MM-DD');
        const endDate = moment(dates[1]).format('YYYY-MM-DD');
        this.$emit('change', { startDate, endDate });
      }
    }
  }
};
</script>

<style scoped>
.date-range-picker {
  width: 100%;
}

/* Override default styles to match your theme */
:deep(.dp__input) {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}

:deep(.dp__input:hover) {
  border-color: #003f2d;
}

:deep(.dp__input:focus) {
  border-color: #003f2d;
  box-shadow: 0 0 0 1px #003f2d;
}

:deep(.dp__active_date) {
  background-color: #003f2d;
}

:deep(.dp__range_start),
:deep(.dp__range_end) {
  background-color: #003f2d;
}

:deep(.dp__range_between) {
  background-color: rgba(0, 63, 45, 0.1);
}
</style>
